import React, { forwardRef, useCallback, useEffect, useMemo, useReducer, useRef, useState } from 'react'
import { useForm, useFormState } from "react-hook-form"
import InputMask from 'react-input-mask';
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { useWizard } from 'react-use-wizard'
import { Button, Col, Form, FormFeedback, FormGroup, Input, InputGroup, Label, Row } from 'reactstrap'
import DatePicker from 'react-datepicker'
import { addHours, getHours, getMinutes, getSeconds, isToday, isFuture, roundToNearestMinutes, setHours, setMinutes, setSeconds, subDays, subYears } from 'date-fns'
import { ArrowRight, Calendar3Event } from 'react-bootstrap-icons'
import LabelBold from './widgets/LabelBold'
import FormControlSubHint from './widgets/FormControlSubHint'
import FormControlHint from './widgets/FormControlHint'
import { BenefitNetworkSelect, InsurerSelect, ProviderSelect } from './StepClinicInformationDropDowns'
import { useClinicService } from '../services/ClinicService'
import StepClinicInformationOptionalInsurance from './StepClinicInformationOptionalInsurance'
import StepClinicInformationPIWC from './StepClinicInformationPIWC'
import useWizardContext from '../contexts/WizardContext';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginPdfPreview from "filepond-plugin-pdf-preview";
import FilePondPluginFileMetadata from 'filepond-plugin-file-metadata';
import { useIntakeFormService } from '../services/IntakeFormService';
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond-plugin-pdf-preview/dist/filepond-plugin-pdf-preview.min.css";
// At the top of your file, with other imports from 'react-router-dom':
import { createSearchParams } from 'react-router-dom';
import { useLocation } from "react-router-dom";


// Register the FilePond plugins
registerPlugin(
    FilePondPluginImageExifOrientation,
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview,
    FilePondPluginPdfPreview,
    FilePondPluginFileMetadata
);


const DateInput = forwardRef(({ value, onClick, onChange, message, ...rest }, ref) => (
    <InputGroup className='input-group-link'>
        <Input
            type='text'
            value={value}
            onFocus={onClick}
            ref={ref}
            required
            onChange={onChange}
            {...rest} />
        <Button color='link' onClick={(e) => { e.target.blur(); e.target.parentElement.blur(); onClick(e); }}><Calendar3Event /></Button>
        {rest.invalid && (
            <FormFeedback className='ms-1'>{message}</FormFeedback>
        )}
    </InputGroup>
));


//export const benefitNetworkOptions = [{value: 1, label: 'In'}, {value: 2, label: 'Out'}, {value: 3, label: 'Unknown'}]

// const schema = yup.object().shape({
//   insuranceId: yup.string().trim().nullable().required("Insurance ID is required")
// })

// function parseDateString(value, originalValue) {
//   const parsedDate = isDate(originalValue)
//     ? originalValue
//     : parse(originalValue, "MM/dd/yyyy", new Date());

//   return parsedDate;
// }

export const getStartDate = (date, src) => {

    console.log('getStartDate src: ', src)
    //const date = new Date()

    //const currentMinute = getMinutes(date)

    //const minutes = 15;
    //const ms = 1000 * 60 * 15;

    // 👇️ replace Math.round with Math.ceil to always round UP
    // console.log('currentMinute A', currentMinute)
    // console.log('Some Math A', Math.ceil(date.getTime() / ms))
    // console.log(Date(Math.ceil(date.getTime() / ms / 0.25) * ms))

    // doIt('A', 0, 0)
    // doIt('A', 0, 23)
    // doIt('B', 5, 23)
    // doIt('C', 10, 23)
    // doIt('D', 15, 23)
    // doIt('E', 20, 23)
    // doIt('F', 43, 23)
    // doIt('G', 46, 23)
    // const dateA = new Date(2022, 11, 29, 6, 43, 25)
    // const mA = (parseInt((getMinutes(roundToNearestMinutes(dateA, { roundingMethod: 'ceil' })) + 7.5) / 15) * 15) % 60;
    // console.log('mA', mA)

    // const dateB = new Date(2022, 11, 29, 6, 15, 25)
    // const mB = (parseInt(Math.ceil(getMinutes(dateB) + 7.5 / 15)) * 15) % 60;
    // console.log('mB', mB)

    // console.log('Date A:', roundToNearestMinutes(dateA))

    // ****
    // //when the min date was 4 hours or 24 hours.
    // const nearestMinutes = getMinutes(roundToNearestMinutes(date, { roundingMethod: 'ceil' }))
    // const m = (parseInt((nearestMinutes + 15) / 15) * 15) % 60;
    // let minDate = setMinutes(date, m)
    // if (m === 0) {
    //   minDate = addHours(minDate, 1)
    // }
    // //let minDate = roundToNearestMinutes(date, { nearestTo: 15, roundingMethod: 'ceil' })

    // ****
    // //when the min date was 4 hours.
    // //console.log('minDateA', minDate)
    // //minDate = addHours(minDate, 4)
    // //console.log('minDateB', minDate)

    // ****
    // //changed min date to 24 horus
    // minDate = addHours(minDate, 24)

    // ****
    //change again to let them pick any time.
    //block out dates before today.
    //initialize to the 'next' 15 minute block.

    let minDate = date
    if (src === 'init startDate') {
        const nearestMinutes = getMinutes(roundToNearestMinutes(date, { roundingMethod: 'ceil' }))
        const m = (parseInt((nearestMinutes + 15) / 15) * 15) % 60;
        minDate = setMinutes(date, m)
        if (m === 0) {
            minDate = addHours(minDate, 1)
        }

        minDate = addHours(minDate, 24)
    }
    else if (src === 'init minStartDate') {
        minDate = setSeconds(setMinutes(setHours(date, 0), 0), 0)
    }
    else if (src === 'from getExcludedTimes') {
        minDate = setSeconds(setMinutes(setHours(date, 0), 0), 0)
    }

    return minDate
}

const schema = yup.object().shape({
    provider: yup.mixed().transform((curr, orig) => orig === '' ? null : curr).required("Provider Name is required"),
    patientFirstName: yup.string().trim().required("Patient first name is required"),
    patientLastName: yup.string().trim().required("Patient last name is required"),
    patientId: yup.mixed().nullable().notRequired(),
    dob: yup.date().test(
        "Is date greater",
        "Date of Birth cannot be greater than today's date",
        (value) => {
            console.log('dob check', value)
            if (!value) return true;
            return !isFuture(value);
        }
    ),
    benefitNetwork: yup.mixed().transform((curr, orig) => orig === '' ? null : curr).required("Please select weather you want to be IN or OUT of network status requested."),
    insuranceCompany: yup.mixed()
        .transform((curr, orig) => orig === '' ? null : curr)
        .when('isPIWC', {
            is: true,
            then: (schema) => schema.nullable(),
            otherwise: (schema) => schema.nullable()
        }),
    insuranceId: yup.string().when(['insuranceCompany', 'isPIWC'], {
        is: (insuranceCompany, isPIWC) => isPIWC || !insuranceCompany,
        then: yup.string().nullable().notRequired(),
        otherwise: yup.string().trim().required("Insurance ID is required")
    }),
    hasSecondaryInsurance: yup.boolean(),
    secondaryInsuranceCompany: yup.mixed().when("hasSecondaryInsurance", {
        is: true,
        then: yup.mixed().transform((curr, orig) => orig === '' ? null : curr).required("Insurance Company is required"),
    }),
    secondaryInsuranceId: yup.string().when("hasSecondaryInsurance", {
        is: true,
        then: yup.string().trim().required("Insurance ID is required"),
    }),
    isPIWC: yup.boolean(),
    hasAttorney: yup.boolean(),
    attorneyName: yup.string().when(['isPIWC', 'hasAttorney'], {
        is: (isPIWC, hasAttorney) => isPIWC && hasAttorney,
        then: yup.string().trim().required('Attorney Name is required'),
        otherwise: yup.string().nullable()
    }),
    attorneyPhone: yup.string().nullable(),
    attorneyEmail: yup.string().when(['isPIWC', 'hasAttorney'], {
        is: (isPIWC, hasAttorney) => isPIWC && hasAttorney,
        then: yup.string()
            .nullable()
            .test('email-format', 'Please enter a valid email address', function (value) {
                // Allow empty values (nullable)
                if (!value || value.trim() === '') {
                    return true;
                }
                // Validate email format if value is provided
                return yup.string().email().isValidSync(value);
            }),
        otherwise: yup.string().nullable()
    }),
    attorneyFax: yup.string().nullable(),
    caseType: yup.mixed().when('isPIWC', {
        is: true,
        then: yup.mixed()
            .transform((curr, orig) => orig === '' ? null : curr)
            .required('Case Type is required'),
        otherwise: yup.mixed().nullable()
    }),

    //dateOfAccident: yup.date().when('isPIWC', {
    //    is: true,
    //    then: yup.date()
    //        .required('Date of Accident is required for PI/WC cases'),
    //    otherwise: yup.date().nullable()
    //}),
    adjusterEmail: yup.string().when(['isPIWC'], {
        is: (isPIWC) => isPIWC,
        then: yup.string()
            .nullable()
            .test('email-format', 'Please enter a valid email address', function (value) {
                // Allow empty values (nullable)
                if (!value || value.trim() === '') {
                    return true;
                }
                // Validate email format if value is provided
                return yup.string().email().isValidSync(value);
            }),
        otherwise: yup.string().nullable()
    }),
    // Add validation for insurance company email with same logic
    insuranceCompanyEmail: yup.string().when('isPIWC', {
        is: true,
        then: yup.string()
            .nullable()
            .test('email-format', 'Please enter a valid email address', function (value) {
                // Allow empty values (nullable)
                if (!value || value.trim() === '') {
                    return true;
                }
                // Validate email format if value is provided
                return yup.string().email().isValidSync(value);
            }),
        otherwise: yup.string().nullable()
    }),
    // Add validation for payer email (insurance company email) with same logic
    payerEmail: yup.string().when('isPIWC', {
        is: true,
        then: yup.string()
            .nullable()
            .test('email-format', 'Please enter a valid email address', function (value) {
                // Allow empty values (nullable)
                if (!value || value.trim() === '') {
                    return true;
                }
                // Validate email format if value is provided
                return yup.string().email().isValidSync(value);
            }),
        otherwise: yup.string().nullable()
    }),
}).required();


const StepClinicInformation = ({ clinicUniqueId, onToggleFullEV }) => {
    // const doIt = (outPrefix, minutes, seconds) => {
    //   const dateA = new Date(2022, 11, 29, 6, minutes, seconds)
    //   const nearestMinutes = getMinutes(roundToNearestMinutes(dateA, { roundingMethod: 'ceil' }))
    //   const mA = (parseInt((nearestMinutes + 15) / 15) * 15) % 60;
    //   console.log('m' + outPrefix, mA, 'nearestMinutes', nearestMinutes)
    // }
    const intakeService = useIntakeFormService();
    const getRoundedUpTime = (date) => {
        const minutes = date.getMinutes();
        const remainder = 15 - (minutes % 15);
        date.setMinutes(minutes + remainder);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
    };
    const getExcludedTimes = useCallback((date) => {
        const excludedTimes = [];
        const now = new Date();

        if (isToday(date)) {
            const currentHour = getHours(now);
            const currentMinute = getMinutes(now);

            for (let hour = 0; hour < 24; hour++) {
                for (let minute = 0; minute < 60; minute += 15) {
                    // Disable any time before current time
                    if (hour < currentHour || (hour === currentHour && minute <= currentMinute)) {
                        excludedTimes.push(setHours(setMinutes(date, minute), hour));
                    }
                }
            }
        }

        return excludedTimes;
    }, []);
    const clinicService = useClinicService()

    useEffect(() => {
        console.log('useEffect on getExcludedTimes triggered')
        getExcludedTimes(new Date())
    }, [getExcludedTimes])


    //const [searchParams, setSearchParams] = useSearchParam();
    // const [minStartDate, setMinStartDate] = useState(getStartDate(new Date()))
    // const [startDate, setStartDate] = useState(getStartDate(new Date(), 'init startDate'));
    // const [dob, setDob] = useState(setMonth(setDate(subYears(new Date(), 30), 1), 0));
    // const [clinic, setClinic] = useState();
    // const [provider, setProvider] = useState();
    // const [benefitNetwork, setBenefitNetwork] = useState(benefitNetworkOptions[2]);
    // const [urgencyLevelChecked, setUrgencyLevelChecked] = useState([true, false, false])
    // const [excludeTimes, setExcludeTimes] = useState([]);

    const formRef = useRef(null)
    const filePondRef = useRef(null)
    const submittingToastId = useRef(null)
    const doRegister = (fieldName, isSubmitted, errors, registerMe = false) => {
        let registerAttr = {}
        if (registerMe) {
            registerAttr = { registerMe: () => register(fieldName) }
        }
        else {
            registerAttr = { ...register(fieldName) }
        }

        const hasError = !!errors?.[fieldName];
        const result = {
            ...registerAttr,
            "aria-invalid": hasError ? "true" : "false"
        };

        // Only add invalid prop when it's true, otherwise omit it
        if (hasError) {
            result.invalid = true;
        }

        // Only add valid prop when form is submitted and there are no errors
        if (isSubmitted && !hasError) {
            result.valid = true;
        }

        return result;
    }

    const doRegisterSelect = (fieldName, isSubmitted, errors, context, placeholder, applyInvalidClass = false) => {
        let applyClass = {}
        if (applyInvalidClass) {
            applyClass = {
                className: `${!!errors?.[fieldName] ? 'is-invalid' : ''}`
            }
        }

        const hasError = !!errors?.[fieldName];
        const result = {
            registerMe: () => register(fieldName),
            value: context[fieldName],
            "aria-invalid": hasError ? "true" : "false",
            onChange: (opt) => {
                dispatch({ type: 'SET', name: fieldName, value: opt });
                if (fieldName == 'provider') {
                    dispatch({ type: 'SET', name: 'isDoctorTitle', value: opt.title === 1 ? true : false });
                }
            },
            placeholder: placeholder,
            message: errors?.[fieldName]?.message,
            ...applyClass
        };

        // Only add invalid prop when it's true, otherwise omit it
        if (hasError) {
            result.invalid = true;
        }

        // Only add valid prop when form is submitted and there are no errors
        if (isSubmitted && !hasError) {
            result.valid = true;
        }

        return result;
    }

    const doRegisterInput = (fieldName, isSubmitted, errors, context) => {
        return {
            ...doRegister(fieldName, isSubmitted, errors),
            value: context[fieldName],
            onChange: (e) => dispatch({ type: 'SET', name: e.target.name, value: e.target.value })
        }
    }

    const doRegisterDateInput = (fieldName, isSubmitted, errors) => {
        return {
            message: errors?.[fieldName]?.message,
            ...doRegister(fieldName, isSubmitted, errors)
        }
    }

    /*const initialState = useMemo(() => { return {
      locationUniqueId: 'D271AC28-0269-4F09-8B4A-BF1A94CA720A',
      minStartDate: getStartDate(new Date(), 'init minStartDate'),
      startDate: getStartDate(new Date(), 'init startDate'),
      dob: setMonth(setDate(subYears(new Date(), 30), 1), 0),
      clinic: '',
      provider: '',
      patientFirstName: '',
      patientLastName: '',
      insuranceCompany: '',
      insuranceId: '',
      hasSecondaryInsurance: false,
      secondaryInsuranceCompany: '',
      secondaryInsuranceId: '',
      benefitNetwork: benefitNetworkOptions[2],
      urgencyLevelChecked: [true, false, false],
      excludeTimes: [],
    }}, [getStartDate, benefitNetworkOptions])*/

    const {
        //isLoading,
        //isLastStep,
        //isFirstStep,
        activeStep,
        //stepCount,
        //previousStep,
        nextStep,
        //goToStep,
        handleStep,
    } = useWizard();

    // const {
    //   register,
    //   handleSubmit,
    //   reset,
    //   formState: { errors }
    // } = useForm({
    //   resolver: yupResolver(schema)
    // })

    const { valueA, valueB, reducer, StepState, setActiveStep } = useWizardContext()

    const getDefaultFormValues = useCallback(() => {
        const {
            // eslint-disable-next-line no-unused-vars
            isSubmitted,
            // eslint-disable-next-line no-unused-vars
            errors,
            // eslint-disable-next-line no-unused-vars
            data,
            // eslint-disable-next-line no-unused-vars
            submitResults,
            // eslint-disable-next-line no-unused-vars
            setValue,
            // eslint-disable-next-line no-unused-vars
            minStartDate,
            // eslint-disable-next-line no-unused-vars
            excludeTimes,
            ...formFields
        } = StepState[activeStep]

        return formFields
    }, [])

    const {
        setFocus,
        register,
        setValue,
        getFieldState,
        handleSubmit,
        trigger,
        control,
        formState: { errors, isSubmitted }
    } = useForm({
        defaultValues: getDefaultFormValues(),
        resolver: yupResolver(schema),
    });

    // const { errors } = useFormState({
    //   control
    // });

    //const {insuranceIdRef,...registerInsuranceId} = register('insuranceId');

    //console.log(errors)
    //console.log(isSubmitted)
    //console.log('dob errors:', errors?.dob ? true : false)
    //console.log('insuranceId errors:', errors?.insuranceId ? true : false)
    //console.log('insuranceCompany errors:', errors?.insuranceCompany ? true : false)

    // const stateReducer = (state, action) => {
    //   console.log('action.name', action.name, 'action.value', action.value)

    //   switch (action.type) {
    //     case 'SET': {
    //       setValue(action.name, action.value, { shouldValidate: isSubmitted })

    //       return {
    //         ...state,
    //         [action.name]: action.value
    //       }
    //     }
    //     default:
    //       return state
    //   }
    // }

    const navigate = useNavigate();
    //console.log('Inside Step 1 and activeStep', activeStep, StepState[0])
    const [state, dispatch] = useReducer(reducer, StepState[0])
    const [isSubmitting, setIsSubmitting] = useState(false);
    const notifyFullEVToggle = useCallback((isChecked) => {
        if (typeof onToggleFullEV === 'function') {
            onToggleFullEV(!!isChecked)
        }
    }, [onToggleFullEV])
    //console.log('state.insuranceId', state.insuranceId)

    useEffect(() => {
        loadClinic();
        loadHolidays();
        handleBenefitNetworkChange();
        setValue('dob', state.dob)
        setValue('dateOfAccident', state.dateOfAccident)
        setValue('benefitNetwork', state.benefitNetwork)
        setValue('wasLopSent', state.wasLopSent)

        //console.log('valueA', valueA)
        //console.log('valueB', valueB)
    }, [])

    useEffect(() => {
        if (state.isSubmitted === false && isSubmitted) {
            dispatch({ type: 'SET', name: 'isSubmitted', value: isSubmitted })
        }

        dispatch({ type: 'SET', name: 'setValue', value: setValue })
    }, [setValue, state.isSubmitted, isSubmitted])
    //useEffect(() => {
    //    // Inform parent about current toggle state on mount and whenever it changes
    //    notifyFullEVToggle(state.isPIWC)
    //}, [state.isPIWC, notifyFullEVToggle])


    useEffect(() => {
        // Inform parent about current toggle state on mount and whenever it changes
        notifyFullEVToggle(state.fullEVOrAccumulationsBenefits || state.isPIWC)
    }, [state.fullEVOrAccumulationsBenefits, state.isPIWC, notifyFullEVToggle])

    useEffect(() => {
        //dispatch({ type: 'CHANGE_STEP', name: 'activeStep', value: activeStep })
        setActiveStep(activeStep)
    }, [activeStep, setActiveStep])

    //trigger will change on the first load. It's only way to run the validation on the default values.
    useEffect(() => {
        if (state.isSubmitted) {
            trigger()
        }
    }, [trigger, state.isSubmitted, state.hasSecondaryInsurance, state.isPIWC, state.hasAttorney])  // Add isPIWC and hasAttorney dependencies
    useEffect(() => {
        const loadPrescriberOtherGroup = async () => {
            // Only make the call if a provider is selected (i.e., state.provider has a value)
            if (state.provider) {
                try {
                    var data = await clinicService.GetOtherGroups(state.provider.value);
                    dispatch({ type: 'SET', name: 'clinicOtherGroup', value: data });
                } catch (error) {
                    // Handle errors during the API call
                    console.error("Error loading other groups:", error);
                }
            }
        };

        loadPrescriberOtherGroup(); // Call the async function whenever state.provider changes

    }, [state.provider, dispatch]);
    useEffect(() => {
        const loadCPTGroup = async () => {
            // Only make the call if a provider is selected (i.e., state.provider has a value)
            if (state.provider) {
                try {
                    var data = await clinicService.GetCPTGroup(state.provider.value);
                    dispatch({ type: 'SET', name: 'clinicCPT', value: data });
                } catch (error) {
                    // Handle errors during the API call
                    console.error("Error loading other groups:", error);
                }
            }
        };

        loadCPTGroup(); // Call the async function whenever state.provider changes

    }, [state.provider, dispatch]);
    useEffect(() => {
        const GetPrescriberValue = async () => {
            // Only make the call if a provider is selected (i.e., state.provider has a value)
            if (state.provider) {
                try {
                    var data = await clinicService.GetPrescriberValue(state.provider.value);
                    dispatch({ type: 'SET', name: 'PrescriberCPT', value: data });
                } catch (error) {
                    // Handle errors during the API call
                    console.error("Error loading other groups:", error);
                }
            }
        };

        GetPrescriberValue(); // Call the async function whenever state.provider changes

    }, [state.provider, dispatch]);

    //useEffect(() => {
    //    dispatch({ type: 'SET', name: 'benefitNetwork', value: null });
    //}, [setValue, state.isSubmitted ,state.benefitNetwork]);

    const loadClinic = async () => {
        var data = await clinicService.GetClinic(state.locationUniqueId)
        console.log('clinic', data)

        if (!data) {
            navigate('/')
        }

        dispatch({ type: 'SET', name: 'clinic', value: data });
        if (data) {
            dispatch({ type: 'SET', name: 'isDME', value: data.isDME });
        }
    }


    const handleBenefitNetworkChange = (selectedOption) => {
        dispatch({ type: 'SET', name: 'benefitNetwork', value: selectedOption });

        // Update ASP.NET dropdown via JavaScript
        if (selectedOption) {
            const benefitNetworkValue = selectedOption.value; // Assuming `value` holds the ID
            window.dispatchEvent(new CustomEvent("benefitNetworkChange", { detail: benefitNetworkValue }));
        }
    };


    const loadHolidays = async () => {
        var data = await clinicService.GetHoliday(state.holidayId);
        //console.log("Holiday Data:", data); 

        if (!Array.isArray(data)) {
            console.error("Invalid holiday data:", data);
            data = [];
        }

        dispatch({ type: "SET", name: "holidays", value: data });
    };

    // // Async function
    handleStep(async (e) => {
        //await fetch(...);
        // console.log(e)
        // console.log('handleStep triggered')
        // console.log('formRef', formRef)
        // console.log('formRef.current', formRef.current)
        // formRef.current.props.onSubmit(e)
        // formRef.current.submit()
    });
    const gotToNextStep = (e) => {
        // Prevent multiple submissions
        if (isSubmitting) {
            return;
        }

        if (state.fullEVOrAccumulationsBenefits || state.isPIWC) {
            setIsSubmitting(true); // Disable button immediately

            handleSubmit(
                (data) => {
                    // ✅ valid case
                    submittingToastId.current = toast.success('Submitting', {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: false,
                    });
                    onSubmit(data); // call your submit function
                },
                (stepErrors) => {
                    // ❌ invalid case - re-enable button on error
                    setIsSubmitting(false);

                    dispatch({ type: 'SET', name: 'errors', value: stepErrors });

                    toast.error('Please correct all errors.', {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                    });
                }
            )(e); // pass the event
        }
        else {
            formRef.current.props.onSubmit(e);
        }
    };
    
    if (!state.startDate) {
        let tomorrowDate = new Date();
        tomorrowDate.setDate(tomorrowDate.getDate() + 1);
        const minutes = tomorrowDate.getMinutes();
        const roundedMinutes = Math.ceil(minutes / 15) * 15;
        tomorrowDate.setMinutes(roundedMinutes);

        if (roundedMinutes === 60) {
            tomorrowDate.setHours(tomorrowDate.getHours(), 0);
        }

        dispatch({ type: 'SET', name: 'startDate', value: tomorrowDate });
    }
    // // Return promise
    // handleStep(() => {
    //   return fetch(...);
    // });
    const UrgencyLevels = ({ onChange, urgencyLevelChecked }) => {
        //const [urgencyLevelChecked, setUrgencyLevelChecked] = useState([true, false, false])
        //if (!state.startDate) {
        //    let tomorrowDate = new Date();
        //    tomorrowDate.setDate(tomorrowDate.getDate() + 1);
        //    const minutes = tomorrowDate.getMinutes();
        //    const roundedMinutes = Math.ceil(minutes / 15) * 15;
        //    tomorrowDate.setMinutes(roundedMinutes);

        //    if (roundedMinutes === 60) {
        //        tomorrowDate.setHours(tomorrowDate.getHours(), 0);
        //    }

        //    dispatch({ type: 'SET', name: 'startDate', value: tomorrowDate });
        //}
        const urgencyLevelDefs = useMemo(() => {
            return [
                {
                    id: 1,
                    option: 'Standard - 24h',
                    className: 'mt-3',
                    style: {}
                }, {
                    id: 2,
                    option: 'Urgent - 4h',
                    className: 'mt-3',
                    style: {}
                }, {
                    id: 3,
                    option: 'Re-Verification - URGENT',
                    className: 'mt-0',
                    style: { visibility: 'hidden', height: '0px' }
                }
            ]
        }, [])



        const isHoliday = (date, holidays = []) => {
            if (!Array.isArray(holidays)) {
                console.error("Holidays is not an array:", holidays);
                return false;
            }
            return holidays.some(holiday => {
                const holidayDate = new Date(holiday.holidayDate); // Convert holiday to Date object
                return (
                    holidayDate.getFullYear() === date.getFullYear() &&
                    holidayDate.getMonth() === date.getMonth() &&
                    holidayDate.getDate() === date.getDate()
                );
            });
        };

        const setUrgencyLevelAnswer = useCallback((e) => {
            let newValues = new Array(state.urgencyLevelChecked.length).fill(false)
            const index = e.target.value
            newValues[index] = true

            //setUrgencyLevelChecked(newValues)

            onChange(newValues)

            if (index === '1') { // "Urgent - 4h"
                const urgentDate = calculateUrgentDate(4);
                dispatch({ type: 'SET', name: 'startDate', value: urgentDate });
            }
            else if (index === '0') { // "Standard - 24h"
                let updatedDate = new Date(); // Get the current date & time
                updatedDate.setDate(updatedDate.getDate() + 1); // Move to the next day
                const minutes = updatedDate.getMinutes();
                const roundedMinutes = Math.ceil(minutes / 15) * 15;
                updatedDate.setMinutes(roundedMinutes);

                // 15-minute increment 
                if (roundedMinutes === 60) {
                    updatedDate.setHours(updatedDate.getHours(), 0);
                }

                // Skip weekends (Saturday & Sunday) and holidays
                //while ([0, 6].includes(updatedDate.getDay()) || isHoliday(updatedDate, state.holidays)) {
                //    console.log(`Skipping Date: ${updatedDate.toISOString().split("T")[0]} (Weekend or Holiday)`);

                //    updatedDate.setDate(updatedDate.getDate() + 1);
                //    updatedDate.setHours(businessStartHour, 0, 0, 0); // Reset to business start hour
                //}

                dispatch({ type: 'SET', name: 'startDate', value: updatedDate });
            }

            // for(let i = 0; i < state.urgencyLevelChecked.length; i++) {
            //   state.urgencyLevelChecked[i] = i === parseInt(e.target.value)
            // }

            // dispatch({ type: 'SET', name: 'urgencyLevelChecked', value: state.urgencyLevelChecked })

        }, [onChange, state.startDate])

        const calculateUrgentDate = (additionalHours) => {
            const businessStartHour = 8; // 8 AM
            const businessEndHour = 17; // 5 PM
            let updatedDate = new Date(); // Current date & time
            const minutes = updatedDate.getMinutes();
            const roundedMinutes = Math.ceil(minutes / 15) * 15;
            updatedDate.setMinutes(roundedMinutes);

            if (updatedDate.getHours() >= businessEndHour) {
                updatedDate.setHours(businessEndHour);
                updatedDate.setMinutes(0);
            }
            else if (updatedDate.getHours() < businessStartHour) {
                updatedDate.setHours(businessStartHour, 0, 0, 0);
                updatedDate.setHours(businessStartHour);// Add 4 hours to 8 AM
            }

            let newHour = updatedDate.getHours() + additionalHours;

            if (newHour >= businessEndHour) {
                // adding 4 hours goes beyond 5 PM, push to next day
                let extraHours = newHour - businessEndHour;
                updatedDate.setDate(updatedDate.getDate() + 1); // Move to next day
                updatedDate.setHours(businessStartHour + extraHours, updatedDate.getMinutes(), updatedDate.getSeconds());
            }
            else {
                updatedDate.setHours(newHour);
            }

            // Skip weekends (Saturday & Sunday) and holidays
            while ([0, 6].includes(updatedDate.getDay()) || isHoliday(updatedDate, state.holidays)) {
                console.log(`Skipping Date: ${updatedDate.toISOString().split("T")[0]} (Weekend or Holiday)`);

                updatedDate.setDate(updatedDate.getDate() + 1);
                //updatedDate.setHours(businessStartHour, 0, 0, 0); // Reset to business start hour
            }

            // If past business hours, move to next day
            if (updatedDate.getHours() >= businessEndHour) {
                updatedDate.setDate(updatedDate.getDate() + 1);
                updatedDate.setHours(businessStartHour, 0, 0, 0);
            }

            return updatedDate;
        };

        return (
            <div className='fw-normal' style={{ fontSize: '1.15em' }}>
                {
                    urgencyLevelDefs.map((answer, index) =>
                        <div key={answer.id} className={answer.className} style={answer.style}>
                            <Label check>
                                <Input type='checkbox'
                                    value={index}
                                    checked={urgencyLevelChecked[index]}
                                    onChange={setUrgencyLevelAnswer}>
                                </Input> {answer.option}
                            </Label>
                        </div>
                    )}
            </div>
        )
    }

    // const submitForm = (e) => {
    //   e.preventDefault();
    //   //console.log(`Email: ${ this.state.email }`);
    //   console.log('for submitting!')
    // }

    // const onSubmit = (data) => {
    //   console.log(data);
    // };
    const [serverMessage, setServerMessage] = useState("");
    useEffect(() => {
        if (serverMessage) {
            document.body.style.overflow = "hidden"; // disable scrolling
        } else {
            document.body.style.overflow = "auto"; // enable scrolling again
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [serverMessage]);
    const onSubmit = async (data, e) => {
        
        const files = filePondRef.current.getFiles()
        data.filepond = []
        files.forEach(file => {
            console.log("file.serverId", file.serverId)
            let str = file.serverId
            if (str.startsWith("\"") && str.endsWith("\"")) {
                str = str.substring(1, str.length - 1);
            }
            data.filepond.push(str)
        });
        console.log('submitted data', data.wasLopSent);
        dispatch({ type: 'SET', name: 'errors', value: [] })
        dispatch({ type: 'SET', name: 'data', value: data })
        dispatch({ type: 'SET', name: 'isSubmitted', value: true })
        if (submittingToastId.current) {
            toast.dismiss(submittingToastId.current);
            submittingToastId.current = null;
        }
        try {
            let payload = {
                Clinic: data.locationUniqueId,
                RequestedBackDate: data.startDatestartDate,
                DateOfBirth: data.dob,
                Provider: data.provider.value,
                PatientFirstName: data.patientFirstName,
                PatientLastName: data.patientLastName,
                PatientId: data.patientId || "",
                InsuranceCards: data.filepond || [],
                InsuranceCompany: data.insuranceCompany?.value && !isNaN(data.insuranceCompany.value) && data.insuranceCompany.value > 0
                    ? data.insuranceCompany.value
                    : null,
                InsuranceCompanyName: data.insuranceCompany?.label || "",
                InsuranceId: data.insuranceId || "",
            };
            if (!data.isPIWC) {
                payload.RequestedBackDate = data.startDatestartDate; // Fixed: was data.startDatestartDate
            }

            let shouldSubmit = false; // ✅ flag to decide if API should be called

            // 🔹 Case 1: EV or Accumulations
            if (state.fullEVOrAccumulationsBenefits) {
                payload.IsAccumulationsBenefits = true;
                shouldSubmit = true;
            }

            // 🔹 Case 2: PIWC
            if (data.isPIWC) {
                shouldSubmit = true;
                payload.IsPIWC = true;

                if (data.dateOfAccident) {
                    const d = new Date(data.dateOfAccident);
                    payload.PI_DateOfAccident = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
                }

                Object.assign(payload, {
                    IDCaseType: parseInt(data.caseType) || 0,
                    PayerClaimNo: data.insuranceClaimNumber || "",
                    PayerName: data.insuranceCompany?.label || "",
                    PayerPhoneNo: data.insuranceCompanyPhone || "",
                    PayerFaxNo: data.insuranceCompanyFax || "",
                    PayerEmail: data.insuranceCompanyEmail || "",
                    AdjusterPhoneNo: data.adjusterPhone || "",
                    AdjusterFaxNo: data.adjusterFax || "",
                    AdjusterEmail: data.adjusterEmail || "",
                    PIClaimNumber: data.piwcClaimNumber || "",
                    DoesHaveAttorney: data.hasAttorney || false,
                    AttorneyName: data.attorneyName || "",
                    AttorneyPhoneNo: data.attorneyPhone || "",
                    AttorneyFaxNo: data.attorneyFax || "",
                    AttorneyEmail: data.attorneyEmail || "",
                    IsSentLopAttorney: data.wasLopSent || false,
                    PI_AdjusterName: data.adjusterName || ""
                });
            }

            if (shouldSubmit) {
                // ✅ Submit once for both cases
                const saveResults = await intakeService.SaveIntakeData(payload);

                if (saveResults.isSuccess) {
                    navigate({
                        pathname: `/IntakeComplete/${data.locationUniqueId}`,
                        search: createSearchParams({
                            internalRef: saveResults.internalRef
                        }).toString()
                    });
                }
                if (!saveResults.isSuccess) {
                    setServerMessage(saveResults.message);   // 🔥 Set message for UI display
                    setIsSubmitting(false);
                    return;
                }

                else {
                    toast.error(saveResults.message, {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    return 0;
                }
                
            } else {
                setIsSubmitting(false);
                // ✅ Normal wizard flow (no API submit yet)
                nextStep();
            }

        } catch (error) {
            console.error("Submit API error:", error);
            toast.error("Error while submitting intake.", { position: "bottom-right" });
        }

    };

    const onError = (stepErrors, e) => {
        dispatch({ type: 'SET', name: 'errors', value: stepErrors })
        console.log(errors, e)

        const firstError = Object.keys(stepErrors).reduce((field, a) => {
            //return !!stepErrors[field] && stepErrors[field].ref ? field : a;
            return !!stepErrors[field] ? field : a;
        }, null);

        if (firstError) {
            console.log('set focus call', firstError)
            //firstError.ref.focus()
            //setFocus(firstError.ref);
        }

        toast.error('Please correct all errors.', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false
        })
    }

    const isLoadingCheck = () => {
        var isLoading = filePondRef.current.getFiles().filter(x => x.status !== 5).length !== 0;
        if (isLoading) {
            //setDisableNavigationLastStep(true)
            //dispatch({ type: 'SET', name: 'disableNavigationLastStep', value: true })
            //setDisabledLastStep(true)
        } else {
            //dispatch({ type: 'SET', name: 'disableNavigationLastStep', value: false })
            //setDisableNavigationLastStep(false)
            //setDisabledLastStep(false)
        }
    }

    return (
        <div className='mb-3'>
            {serverMessage && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.5)", // dark overlay
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,   // ensures it's on top
                    }}
                >
                    <div
                        style={{
                            background: "#ffe5e5",
                            padding: "20px 30px",
                            borderRadius: "8px",
                            color: "#b30000",
                            fontWeight: "bold",
                            fontSize: "20px",
                            textAlign: "center",
                            maxWidth: "500px"
                        }}
                    >
                        {serverMessage}
                    </div>
                </div>
            )}

            {/* <Form ref={formRef} onSubmit={handleSubmit(onSubmit)}> */}
            <Form ref={formRef} onSubmit={handleSubmit(onSubmit, onError)/*((d) => console.log('d', d))*/}>
                {/*{!state.fullEVOrAccumulationsBenefits && (*/}
                {/*    <Row className='mt-3'>*/}
                {/*        <Col sm={4}>*/}
                {/*            <LabelBold>Is this for a PI/WC Patient Case?</LabelBold>*/}
                {/*        </Col>*/}
                {/*        <Col sm={4} className='pe-4'>*/}
                {/*            <Row>*/}
                {/*                <Col sm={6}>*/}
                {/*                    <div className='d-flex justify-content-around flex-row'>*/}
                {/*                        <div>No</div>*/}
                {/*                        <div className="form-check form-switch">*/}
                {/*                            <input*/}
                {/*                                className='form-check-input'*/}
                {/*                                type='checkbox'*/}
                {/*                                id='isPIWC'*/}
                {/*                                name='isPIWC'*/}
                {/*                                onChange={(e) =>*/}
                {/*                                    dispatch({*/}
                {/*                                        type: 'SET',*/}
                {/*                                        name: 'isPIWC',*/}
                {/*                                        value: e.target.checked,*/}
                {/*                                    })*/}
                {/*                                }*/}
                {/*                                checked={state.isPIWC || false}*/}
                {/*                                style={{ transform: 'scale(1.6)' }}*/}
                {/*                            />*/}
                {/*                        </div>*/}
                {/*                        <div>Yes</div>*/}
                {/*                    </div>*/}
                {/*                </Col>*/}
                {/*            </Row>*/}
                {/*        </Col>*/}
                {/*    </Row>*/}
                {/*)}*/}
                {/*{!state.isPIWC && (*/}
                {/*    <Row className='mt-3'>*/}
                {/*        <Col sm={4}>*/}
                {/*            <LabelBold>Do you want just an Accumulation of Benefits?</LabelBold>*/}
                {/*        </Col>*/}
                {/*        <Col sm={4} className='pe-4'>*/}
                {/*            <Row>*/}
                {/*                <Col sm={6}>*/}
                {/*                    <div className='d-flex justify-content-around flex-row'>*/}
                {/*                        <div>No</div>*/}
                {/*                        <div className="form-check form-switch">*/}
                {/*                            <input*/}
                {/*                                className='form-check-input'*/}
                {/*                                type='checkbox'*/}
                {/*                                id='fullEVOrAccumulationsBenefits'*/}
                {/*                                name='fullEVOrAccumulationsBenefits'*/}
                {/*                                onChange={(e) =>*/}
                {/*                                    dispatch({*/}
                {/*                                        type: 'SET',*/}
                {/*                                        name: 'fullEVOrAccumulationsBenefits',*/}
                {/*                                        value: e.target.checked,*/}
                {/*                                    })*/}
                {/*                                }*/}
                {/*                                checked={state.fullEVOrAccumulationsBenefits}*/}
                {/*                                style={{ transform: 'scale(1.6)' }}*/}
                {/*                            />*/}
                {/*                        </div>*/}
                {/*                        <div>Yes</div>*/}
                {/*                    </div>*/}
                {/*                </Col>*/}
                {/*            </Row>*/}
                {/*        </Col>*/}
                {/*    </Row>*/}
                {/*)}*/}

                <Row className='mt-4'>
                    <Col xs={12}>
                        <LabelBold>
                            {state.isPIWC ? 'Case Documentation & Ins. Info' : 'Insurance Card'}
                        </LabelBold>
                    </Col>
                </Row>


                <Row className='mt-3'>
                    <Col md={12} lg={8} xxl={6}>
                        {/* <Dashboard
                uppy={uppy}
                width='100%'
                height={600}
                proudlyDisplayPoweredByUppy={false}
                showProgressDetails={true}
                plugins={['Webcam', 'ImageEditor']}
              /> */}

                        <FilePond
                            ref={filePondRef}
                            //files={getCards()}
                            files={state.insuranceCards}
                            pdfComponentExtraParams='navpanes=0&toolbar=1&view=fitW&page=1'
                            server="/attachment"
                            // server={{
                            //   url: "/attachment",
                            //   remove: (source, load, error) => {
                            //     // 'source' is the path of the file and should be sent to a server endpoint via http
                            //     console.log('source to delete', source)

                            //     // call the load method before ending the function
                            //     load()
                            //   },
                            //   process: {
                            //     //url: './process',
                            //     //method: 'POST',
                            //     //headers: {
                            //       //  'x-customheader': 'Hello World'
                            //     //},
                            //     //withCredentials: false,
                            //     onload: (response) => {
                            //       console.log(response)
                            //       //response.key, // is fired

                            //       const files = filePondRef.current.getFiles()
                            //       files.forEach((file, i) => {
                            //         if (!file.getMetadata('customServerId')) {
                            //           console.log('found file without customServerId, setting it to', response)
                            //           file.setMetadata('customServerId', response, true)
                            //           //file.setMetadata('customSource', JSON.stringify(file.source), true)
                            //         }
                            //       })

                            //       // const elements = document.getElementsByClassName('filepond--data')
                            //       // console.log('elements', elements)

                            //       // state.insuranceCards.forEach((file, i) => {
                            //       //   if (elements.length !== 0 && elements[0].childNodes.length !== 0) {
                            //       //     elements[0].childNodes[i].value = file.serverId
                            //       //   }
                            //       // });

                            //       return response
                            //     }
                            //   }
                            // }}
                            onupdatefiles={files => {
                                // files.forEach(file => {
                                //   file.options = {
                                //     type: 'local', // local to indicate an already uploaded file, so it hits the load endpoint
                                //   }
                                // })
                                dispatch({ type: 'SET', name: 'insuranceCards', value: files })
                            }
                            }
                            // {{
                            //   url: "/attachment",
                            //   // load: (source, load, error, progress, abort, headers) => {
                            //   //   console.log(source)

                            //   //   const files = filePondRef.current.getFiles()
                            //   //   files.forEach((file, i) => {
                            //   //     if (file.getMetadata('customServerId') === source) {
                            //   //       console.log('found customServerId matching source', file)
                            //   //       console.log('meta cust src:', file.getMetadata('customSource'))

                            //   //       load(JSON.parse(file.getMetadata('customSource')))
                            //   //     }
                            //   //     /*console.log('init file.source', file.source)
                            //   //     console.log('init file.id', file.id)
                            //   //     console.log('init file.serverId', file.serverId)*/
                            //   //     //file.setMetadata('customeServerId', files2[i].file.serverId)


                            //   //   })

                            //   // },
                            //   // revert: (uniqueFileId, load, error) => {
                            //   //   console.log('revert uniqueFileId', uniqueFileId)

                            //   //   load();
                            //   // },
                            //   process: {
                            //     //url: './process',
                            //     //method: 'POST',
                            //     //headers: {
                            //       //  'x-customheader': 'Hello World'
                            //     //},
                            //     //withCredentials: false,
                            //     onload: (response) => {
                            //       console.log(response)
                            //       //response.key, // is fired

                            //       const files = filePondRef.current.getFiles()
                            //       files.forEach((file, i) => {
                            //         if (!file.getMetadata('customServerId')) {
                            //           console.log('found file without customServerId, setting it to', response)
                            //           file.setMetadata('customServerId', response, true)
                            //           file.setMetadata('customSource', JSON.stringify(file.source), true)
                            //         }
                            //         /*console.log('init file.source', file.source)
                            //         console.log('init file.id', file.id)
                            //         console.log('init file.serverId', file.serverId)*/
                            //         //file.setMetadata('customeServerId', files2[i].file.serverId)
                            //       })

                            //       // const elements = document.getElementsByClassName('filepond--data')
                            //       // console.log('elements', elements)

                            //       // state.insuranceCards.forEach((file, i) => {
                            //       //   if (elements.length !== 0 && elements[0].childNodes.length !== 0) {
                            //       //     elements[0].childNodes[i].value = file.serverId
                            //       //   }
                            //       // });

                            //       return response
                            //     }
                            //     // },
                            //     // ondata: (formData) => {
                            //     //   console.log(formData)
                            //     //   // add metadata
                            //     //  // formData.append('usermeta', JSON.stringify(pondMetadata));

                            //     //   //formData.append('userid', '2');
                            //     //   //formData.append('usercom', '1');
                            //     //   return formData;
                            //     // }
                            //   }
                            // }}
                            captureMethod={['camera']}
                            //acceptedFileTypes={['image/png', 'image/jpeg', 'image/gif']}
                            acceptedFileTypes={['image/*', 'application/pdf']}
                            // oninit={() => {
                            //   const files = filePondRef.current.getFiles()
                            //   const files2 = state.insuranceCards
                            //   files.forEach((file, i) => {
                            //     console.log('init file.source', file.source)
                            //     console.log('init file.id', file.id)
                            //     console.log('init file.serverId', file.serverId)
                            //     //file.setMetadata('customeServerId', files2[i].file.serverId)
                            //   })

                            //   // const files2 = state.insuranceCards
                            //   // files2.forEach((file, i) => {
                            //   //   console.log('init file2.source', file.source)
                            //   //   console.log('init file2.id', file.id)
                            //   //   console.log('init file2.serverId', file.serverId)
                            //   // })
                            // }}
                            allowReorder={false}
                            itemInsertLocationFreedom={false}
                            allowMultiple={true}
                            allowFileMetadata={true}
                            onaddfilestart={(file) => {
                                console.log('onaddfilestart do loading check')
                                isLoadingCheck()
                            }}
                            onprocessfiles={() => {
                                console.log('onprocessfiles do loading check')
                                isLoadingCheck()
                            }}
                            onprocessfileabort={() => {
                                console.log('onprocessfileabort do loading check')
                                isLoadingCheck()
                            }}
                            onprocessfilerevert={() => {
                                console.log('onprocessfilerevert do loading check')
                                isLoadingCheck()
                            }}
                            onremovefile={() => {
                                console.log('onremovefile do loading check')
                                isLoadingCheck()
                            }}
                            // onupdatefiles={(files) => {
                            //   console.log('---------------------------------')
                            //   console.log('onupdatefiles')
                            //   console.log('---------------------------------')
                            //   // files.forEach(file => {

                            //   //   console.log('status', file.status)

                            //   //   file.options = {
                            //   //     type: 'local', // local to indicate an already uploaded file, so it hits the load endpoint
                            //   //     // fileMetadataObject: {
                            //   //     //   customServerId: file.serverId,
                            //   //     // }
                            //   //   }
                            //   // });

                            //   //const files = filePondRef.current.getFiles()

                            //   const elements = document.getElementsByClassName('filepond--data')
                            //   console.log('elements', elements)

                            //   state.insuranceCards.forEach((file, i) => {
                            //     if (elements.length !== 0 && elements[0].childNodes.length !== 0) {
                            //       elements[0].childNodes[i].value = file.getMetadata('customServerId')
                            //     }

                            //     console.log('status', file.status)

                            //     // if (file.serverId) {
                            //     //   filePondRef.current.setOptions({
                            //     //     type: 'limbo',
                            //     //     fileMetadataObject: {
                            //     //         'customServerId': file.serverId,
                            //     //     }
                            //     //   })
                            //     // }
                            //     // file.options = {
                            //     //   type: 'limbo', // local to indicate an already uploaded file, so it hits the load endpoint
                            //     //   fileMetadataObject: {
                            //     //     customServerId: file.serverId,
                            //     //   }
                            //     // }
                            //   });

                            //   const newFiles = []

                            //   files.forEach(file => {
                            //     console.log('Getting metadata in update', file.getMetadata('customServerId'))

                            //     var json = JSON.stringify(file)
                            //     var obj = JSON.parse(json)
                            //     obj.source = file.source//file.getMetadata('customServerId')//file.source//file.getMetadata('customServerId')
                            //     obj.serverId = file.getMetadata('customServerId')
                            //     obj.Metadata = {
                            //       customServerId: obj.serverId
                            //     }
                            //     console.log('json', obj)
                            //     //var obj = JSON.

                            //     //console.log(file.source)

                            //     newFiles.push(obj)
                            //   })

                            //   //dispatch({ type: 'SET_INSURANCE_CARDS', name: 'insuranceCards', value: files })
                            //   dispatch({ type: 'SET_INSURANCE_CARDS', name: 'insuranceCards', value: files })
                            // }}
                            // onprocessfiles={() => {
                            // //   const files = filePondRef.current.getFiles()
                            // //   const newFiles = []
                            // //   files.forEach(file => {
                            // //     console.log('Type', file)
                            // //     console.log('getMetadata', file.getMetadata())
                            // //     console.log('file.file', file.file)
                            // //     console.log('file.origin', file.origin)
                            // //     console.log('file.source', file.source)
                            // //     console.log('file.id', file.id)
                            // //     console.log('file.serverId', file.serverId)
                            // //     file.setMetadata('customServerId', file.serverId, true);
                            // //     //file.serverIdBk = file.serverId
                            // //     file.options = {
                            // //       type: 'limbo', // local to indicate an already uploaded file, so it hits the load endpoint
                            // //       /*fileMetadataObject: {
                            // //         customServerId: file.serverId,
                            // //       },*/
                            // //     }
                            // //     newFiles.push(file)
                            // //   });
                            // //   dispatch({ type: 'SET', name: 'insuranceCards', value: newFiles })
                            // }}
                            //  onprocessfile={(err, fileItem) => {
                            //   //console.log('fileItem.customServerId', fileItem.getMetadata('customServerId'))  

                            //   const elements = document.getElementsByClassName('filepond--data')
                            //   console.log('elements', elements)

                            //   state.insuranceCards.forEach((file, i) => {
                            //     if (elements.length !== 0 && elements[0].childNodes.length !== 0) {
                            //       elements[0].childNodes[i].value = file.getMetadata('customServerId')
                            //     }
                            //   });
                            //  }}
                            //   console.log('fileItem.getMetadata', fileItem.getMetadata())
                            //   console.log('fileItem.file', fileItem.file);
                            //   console.log('fileItem.origin', fileItem.origin);
                            //   console.log('fileItem.source', fileItem.source);
                            //   console.log('fileItem.id', fileItem.id)
                            //   console.log('fileItem.serverId', fileItem.serverId)
                            //   console.log('fileItem.customServerId', fileItem.getMetadata('customServerId'))

                            //   console.log('fileItem.serverId has server id?')
                            //   if (fileItem.serverId) {
                            //     console.log('fileItem.serverId has server id?', 'yes!')

                            //     const files = filePondRef.current.getFiles()

                            //     files.forEach((file, i) => {
                            //       console.log('file index', i)
                            //       if (file.serverId === fileItem.serverId) {
                            //         console.log('file index', i, 'are equal serverIds')
                            //         files[i] = fileItem
                            //       }
                            //     })

                            //     dispatch({ type: 'SET_INSURANCE_CARDS', name: 'insuranceCards', value: files })

                            //       //     console.log('fond in session: ', file.getMetadata('customServerId'))
                            //       //     if (file.getMetadata('customServerId')) {

                            //       //     }
                            //       //   });


                            //     // fileItem.setMetadata('customServerId', fileItem.serverId, true);
                            //     // if (state.insuranceCards) {
                            //     //   state.insuranceCards.forEach(file => {
                            //     //     console.log('fond in session: ', file.getMetadata('customServerId'))
                            //     //     if (file.getMetadata('customServerId')) {

                            //     //     }
                            //     //   });
                            //     // }

                            //   }

                            //const files = state.insuranceCards // filePondRef.current.getFiles()
                            // files.forEach((file, i) => {
                            //   //console.log('Type', file)
                            //   //console.log('getMetadata', file.getMetadata())
                            //   console.log('file.file', file.file)
                            //   console.log('file.origin', file.origin)
                            //   console.log('file.source', file.source)
                            //   console.log('file.id', file.id)
                            //   console.log('file.serverId', file.serverId)
                            //   //file.setMetadata('customServerId', file.serverId, true);
                            //   //file.serverIdBk = file.serverId

                            //   // if (file.serverId === fileItem.serverId) {
                            //   //   file.options = {
                            //   //     type: 'limbo', // local to indicate an already uploaded file, so it hits the load endpoint
                            //   //     /*fileMetadataObject: {
                            //   //       customServerId: file.serverId,
                            //   //     },*/
                            //   //   }

                            //   //   //state.insuranceCards[i] = file
                            //   // }


                            //   //newFiles.push(file)
                            // });
                            //dispatch({ type: 'SET_INSURANCE_CARDS', name: 'insuranceCards', value: state.insuranceCards })
                            //}}
                            labelIdle='Drag & Drop your insurance card photos or <span class="filepond--label-action">Browse</span>'
                        />
                    </Col>
                </Row>

                {!state.isPIWC && (
                    <Row className='mt-3'>
                        <Col md={8} lg={6}>
                            <FormGroup>
                                <LabelBold required>Requested Back Date</LabelBold>
                                <DatePicker
                                    selected={state.startDate}
                                    minDate={state.minStartDate}
                                    onChange={(selected) => {
                                        const excluded = getExcludedTimes(selected);

                                        // If selected date is today and selected time is in the past
                                        const now = new Date();

                                        let finalSelected = selected;

                                        if (isToday(selected) && selected < now) {
                                            finalSelected = getRoundedUpTime(now); // Auto-correct
                                        }

                                        dispatch({ type: 'SET', name: 'startDate', value: finalSelected });
                                        dispatch({ type: 'SET', name: 'excludeTimes', value: excluded });
                                    }}
                                    onSelect={getExcludedTimes}
                                    showTimeSelect
                                    excludeTimes={state.excludeTimes}
                                    timeFormat="p"
                                    timeIntervals={15}
                                    dateFormat="MM/dd/yyyy hh:mm aa"
                                    popperPlacement="bottom"
                                    customInput={<DateInput
                                        mask={[
                                            /[0-1]/, /[0-9]/, //MM
                                            "/",
                                            /[0-3]/, /\d/, //dd
                                            "/", /2/, /\d/, /\d/, /\d/, //yyyy
                                            " ",
                                            /[0-1]/, /[0-9]/, //hh
                                            ":",
                                            /[0-6]/, /[0-9]/, //mm
                                            " ",
                                            /a|A|p|P/,
                                            /m|M/
                                        ]}
                                        tag={InputMask}
                                        {...doRegisterDateInput('startDate', state.isSubmitted, errors)}
                                    />}
                                />
                                <FormControlHint>MM/dd/yyyy HH:ss AM/PM</FormControlHint>
                            </FormGroup>
                        </Col>
                    </Row>
                )}
                {!state.isPIWC && (
                    <Row className='mt-3'>
                        <Col md={8} lg={6}>
                            <FormGroup>
                                <LabelBold required>Urgency Level</LabelBold>
                                <UrgencyLevels
                                    urgencyLevelChecked={state.urgencyLevelChecked}
                                    onChange={(values) => dispatch({ type: 'SET', name: 'urgencyLevelChecked', value: values })} />
                            </FormGroup>
                        </Col>
                    </Row>
                )}
                <Row className='mt-4'>
                    <Col md={12} lg={8} xxl={6}>
                        <FormGroup>
                            <LabelBold>Additional Comments</LabelBold>
                            <Input type="textarea"
                                {...doRegisterInput('additionalComments', state.isSubmitted, errors, state)}
                            ></Input>
                            {errors?.additionalComments && (
                                <FormFeedback className='ms-1'>{errors?.additionalComments?.message}</FormFeedback>
                            )}
                        </FormGroup>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col md={8} lg={6}>
                        <FormGroup>
                            <LabelBold required>Clinic Name</LabelBold>
                            <Input type="text" readOnly defaultValue={state.clinic && state.clinic.name} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col md={8} lg={6}>
                        <FormGroup>
                            <LabelBold required>Provider Name</LabelBold>
                            <ProviderSelect
                                isClearable
                                locationUniqueId={state.locationUniqueId}
                                {...doRegisterSelect('provider', state.isSubmitted, errors, state, 'Select or type name to search')}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col md={4}>
                        <FormGroup>
                            <LabelBold required>Patient Name</LabelBold>
                            <Input
                                type='text'
                                {...doRegisterInput('patientFirstName', state.isSubmitted, errors, state)}
                            />
                            {errors?.patientFirstName && (
                                <FormFeedback className='ms-1'>{errors?.patientFirstName?.message}</FormFeedback>
                            )}
                            <FormControlHint>First Name</FormControlHint>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <LabelBold>&nbsp;</LabelBold>
                            <Input
                                type='text'
                                {...doRegisterInput('patientLastName', state.isSubmitted, errors, state)}
                            />
                            {errors?.patientLastName && (
                                <FormFeedback className='ms-1'>{errors?.patientLastName?.message}</FormFeedback>
                            )}
                            <FormControlHint>Last Name</FormControlHint>
                        </FormGroup>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col md={4}>
                        <FormGroup>
                            <LabelBold>Patient ID</LabelBold>
                            <Input
                                type='text'
                                {...doRegisterInput('patientId', state.isSubmitted, errors, state)}
                            />
                            {errors?.patientId && (
                                <FormFeedback className='ms-1'>{errors?.patientId?.message}</FormFeedback>
                            )}
                        </FormGroup>
                    </Col>
                </Row>

                <Row className='mt-3'>
                    <Col md={8} lg={6}>
                        <FormGroup>
                            <LabelBold required>Date of Birth</LabelBold>
                            <DatePicker
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                selected={state.dob}
                                minDate={subYears(new Date(), 120)}
                                maxDate={new Date()}
                                onChange={(selected) => dispatch({ type: 'SET', name: 'dob', value: selected })}
                                dateFormat="MM/dd/yyyy"
                                popperPlacement="bottom"
                                //value={state.dob}
                                customInput={<DateInput
                                    mask={[/[0-1]/, /[0-9]/, "/", /[0-3]/, /\d/, "/", /[1-2]/, /[9]|[0]/, /\d/, /\d/]}
                                    tag={InputMask}
                                    {...doRegisterDateInput('dob', state.isSubmitted, errors)}

                                /*{...register('dob')}
                                valid={isSubmitted && (!errors?.dob)}
                                invalid={!!errors?.dob}
                                aria-invalid={errors?.dob ? "true" : "false"}
                                message={errors?.dob?.message}*/
                                />}
                            />
                            <FormControlHint>MM/dd/yyyy</FormControlHint>
                        </FormGroup>
                    </Col>
                </Row>
                {!state.fullEVOrAccumulationsBenefits && (<>
                    {!state.isPIWC && (
                        <Row className='mt-3'>
                            <Col md={8} lg={6}>
                                <FormGroup>
                                    <LabelBold>Network Status Requested: </LabelBold>
                                    <BenefitNetworkSelect
                                        isClearable
                                        value={state.benefitNetwork}
                                        {...doRegisterSelect('benefitNetwork', state.isSubmitted, errors, state, 'Select or type name to search')}
                                        onChange={handleBenefitNetworkChange}
                                        className={`${!!errors?.benefitNetwork ? 'is-invalid' : ''}`}
                                    /*{...register('benefitNetwork')}
                                    valid={isSubmitted && (!errors?.benefitNetwork)}
                                    invalid={!!errors?.benefitNetwork}
                                    aria-invalid={errors?.benefitNetwork ? "true" : "false"}
                                    onChange={opt => dispatch({ type: 'SET', name: 'benefitNetwork', value: opt })}
                                    className={`${!!errors?.benefitNetwork? 'is-invalid': ''}`}*/
                                    />
                                    {/* {errors?.benefitNetwork && (
                <FormFeedback className='ms-1'>{errors?.benefitNetwork?.message}</FormFeedback>
              )} */}
                                </FormGroup>
                            </Col>
                        </Row>
                    )}
                    <Row className='mt-3'>
                        <Col md={8} lg={6}>
                            <FormGroup>
                                <LabelBold>Insurance Company</LabelBold>
                                <InsurerSelect
                                    isClearable
                                    //isCreatable={true}
                                    locationUniqueId={state.locationUniqueId}
                                    {...doRegisterSelect('insuranceCompany', state.isSubmitted, errors, state, 'Select existing or add new insurance company name')}
                                /*registerMe={() => register('insuranceCompany')}
                                valid={isSubmitted && (!errors?.insuranceCompany)}
                                invalid={!!errors?.insuranceCompany}
                                aria-invalid={errors?.insuranceCompany ? "true" : "false"}
                                onChange={opt => dispatch({ type: 'SET', name: 'insuranceCompany', value: opt })}
                                placeholder="Select existing or add new insurance company name"
                                message={errors?.insuranceCompany?.message}*/
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col md={8} lg={6}>
                            <FormGroup>
                                <LabelBold>Insurance ID</LabelBold>
                                <Input
                                    type='text'
                                    {...doRegisterInput('insuranceId', state.isSubmitted, errors, state)}
                                /*{...register('insuranceId')}
                                valid={isSubmitted && (!errors?.insuranceId)}
                                invalid={!!errors?.insuranceId}
                                aria-invalid={errors?.insuranceId ? "true" : "false"}
                                value={state.insuranceId}
                                onChange={(e) => dispatch({ type: 'SET', name: e.target.name, value: e.target.value })}*/
                                />
                                {errors?.insuranceId && (
                                    <FormFeedback className='ms-1'>{errors?.insuranceId?.message}</FormFeedback>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col md={8} lg={6}>
                            <FormGroup>
                                <StepClinicInformationOptionalInsurance
                                    title="Does this patient have secondary insurance?"
                                    hint="Please enter the secondary information below"
                                    initiallyChecked={state.hasSecondaryInsurance}
                                    doRegisterInsuranceId={() => { return { ...doRegisterInput('secondaryInsuranceId', state.isSubmitted, errors, state) } }}
                                    doRegisterInsuranceCompany={() => { return { ...doRegisterSelect('secondaryInsuranceCompany', state.isSubmitted, errors, state, 'Select existing or add new insurance company name') } }}
                                    insuranceIdErrorMessage={errors?.secondaryInsuranceId?.message}
                                    onChange={(e) => dispatch({ type: 'SET', name: 'hasSecondaryInsurance', value: e.target.checked })}
                                    locationUniqueId={state.locationUniqueId}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </>
                )}
                {state.isPIWC && (
                    <>
                        <Row className='mt-3'>
                            <Col md={8} lg={6}>
                                <FormGroup>
                                    <LabelBold required>Date of Accident</LabelBold>
                                    <DatePicker
                                        selected={state.dateOfAccident}
                                        maxDate={new Date()}
                                        onChange={(selected) => dispatch({ type: 'SET', name: 'dateOfAccident', value: selected })}
                                        dateFormat="MM/dd/yyyy"
                                        popperPlacement="bottom"
                                        customInput={<DateInput
                                            mask={[/[0-1]/, /[0-9]/, "/", /[0-3]/, /\d/, "/", /[1-2]/, /[9]|[0]/, /\d/, /\d/]}
                                            tag={InputMask}
                                            {...doRegisterDateInput('dateOfAccident', state.isSubmitted, errors)}
                                        />}
                                    />
                                    <FormControlHint>MM/dd/yyyy</FormControlHint>
                                    {errors?.dateOfAccident && (
                                        <FormFeedback className='ms-1'>{errors?.dateOfAccident?.message}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col md={8} lg={6}>
                                <FormGroup>
                                    <LabelBold required>Case Type</LabelBold>
                                    <Input
                                        type='select'
                                        {...doRegisterInput('caseType', state.isSubmitted, errors, state)}
                                    >
                                        <option value="">Select Case Type</option>
                                        <option value="1">Personal Injury</option>
                                        <option value="2">Workers Compensation</option>
                                    </Input>
                                    {errors?.caseType && (
                                        <FormFeedback className='ms-1'>{errors?.caseType?.message}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col md={8} lg={6}>
                                <FormGroup>
                                    <LabelBold>Insurance Claim Number</LabelBold>
                                    <Input
                                        type='text'
                                        {...doRegisterInput('insuranceClaimNumber', state.isSubmitted, errors, state)}
                                    />
                                    {errors?.insuranceClaimNumber && (
                                        <FormFeedback className='ms-1'>{errors?.insuranceClaimNumber?.message}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col md={4}>
                                <FormGroup>
                                    <LabelBold>Phone Number</LabelBold>
                                    <Input
                                        type='tel'
                                        {...doRegisterInput('insuranceCompanyPhone', state.isSubmitted, errors, state)}
                                    />
                                    {errors?.insuranceCompanyPhone && (
                                        <FormFeedback className='ms-1'>{errors?.insuranceCompanyPhone?.message}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <LabelBold>Fax Number</LabelBold>
                                    <Input
                                        type='tel'
                                        {...doRegisterInput('insuranceCompanyFax', state.isSubmitted, errors, state)}
                                    />
                                    {errors?.insuranceCompanyFax && (
                                        <FormFeedback className='ms-1'>{errors?.insuranceCompanyFax?.message}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col md={8} lg={6}>
                                <FormGroup>
                                    <LabelBold>Email Address</LabelBold>
                                    <Input
                                        type='email'
                                        {...doRegisterInput('insuranceCompanyEmail', state.isSubmitted, errors, state)}
                                    />
                                    {errors?.insuranceCompanyEmail && (
                                        <FormFeedback className='ms-1'>{errors?.insuranceCompanyEmail?.message}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col md={4}>
                                <FormGroup>
                                    <LabelBold>Adjuster Name</LabelBold>
                                    <Input
                                        type='text'
                                        {...doRegisterInput('adjusterName', state.isSubmitted, errors, state)}
                                    />
                                    {errors?.adjusterName && (
                                        <FormFeedback className='ms-1'>{errors?.adjusterName?.message}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <LabelBold>Adjuster Phone Number</LabelBold>
                                    <Input
                                        type='tel'
                                        {...doRegisterInput('adjusterPhone', state.isSubmitted, errors, state)}
                                    />
                                    {errors?.adjusterPhone && (
                                        <FormFeedback className='ms-1'>{errors?.adjusterPhone?.message}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <LabelBold>Adjuster Fax Number</LabelBold>
                                    <Input
                                        type='tel'
                                        {...doRegisterInput('adjusterFax', state.isSubmitted, errors, state)}
                                    />
                                    {errors?.adjusterFax && (
                                        <FormFeedback className='ms-1'>{errors?.adjusterFax?.message}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col md={8} lg={6}>
                                <FormGroup>
                                    <LabelBold>Adjuster Email Address</LabelBold>
                                    <Input
                                        type='email'
                                        {...doRegisterInput('adjusterEmail', state.isSubmitted, errors, state)}
                                    />
                                    {errors?.adjusterEmail && (
                                        <FormFeedback className='ms-1'>{errors?.adjusterEmail?.message}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col md={8} lg={6}>
                                <FormGroup>
                                    <LabelBold>PI/WC Claim Number</LabelBold>
                                    <Input
                                        type='text'
                                        {...doRegisterInput('piwcClaimNumber', state.isSubmitted, errors, state)}
                                    />
                                    {errors?.piwcClaimNumber && (
                                        <FormFeedback className='ms-1'>{errors?.piwcClaimNumber?.message}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col sm={4}>
                                <LabelBold>Does this patient have an Attorney?</LabelBold>
                            </Col>
                            <Col sm={4} className='pe-4'>
                                <Row>
                                    <Col sm={6}>
                                        <div className='d-flex justify-content-around flex-row'>
                                            <div>No</div>
                                            <div className="form-check form-switch">
                                                <input
                                                    className='form-check-input'
                                                    type='checkbox'
                                                    id='hasAttorney'
                                                    name='hasAttorney'
                                                    onChange={(e) => dispatch({ type: 'SET', name: 'hasAttorney', value: e.target.checked })}
                                                    checked={state.hasAttorney || false}
                                                    style={{ transform: 'scale(1.6)' }}
                                                />
                                            </div>
                                            <div>Yes</div>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        {state.hasAttorney && (
                            <>
                                <Row className='mt-3'>
                                    <Col md={8} lg={6}>
                                        <FormGroup>
                                            <LabelBold required>Attorney Name</LabelBold>
                                            <Input
                                                type='text'
                                                {...doRegisterInput('attorneyName', state.isSubmitted, errors, state)}
                                            />
                                            {errors?.attorneyName && (
                                                <FormFeedback className='ms-1'>{errors?.attorneyName?.message}</FormFeedback>
                                            )}
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row className='mt-3'>
                                    <Col md={4}>
                                        <FormGroup>
                                            <LabelBold>Attorney Phone Number</LabelBold>
                                            <Input
                                                type='tel'
                                                {...doRegisterInput('attorneyPhone', state.isSubmitted, errors, state)}
                                            />
                                            {errors?.attorneyPhone && (
                                                <FormFeedback className='ms-1'>{errors?.attorneyPhone?.message}</FormFeedback>
                                            )}
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <LabelBold>Attorney Fax Number</LabelBold>
                                            <Input
                                                type='tel'
                                                {...doRegisterInput('attorneyFax', state.isSubmitted, errors, state)}
                                            />
                                            {errors?.attorneyFax && (
                                                <FormFeedback className='ms-1'>{errors?.attorneyFax?.message}</FormFeedback>
                                            )}
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row className='mt-3'>
                                    <Col md={8} lg={6}>
                                        <FormGroup>
                                            <LabelBold>Attorney Email Address</LabelBold>
                                            <Input
                                                type='email'
                                                {...doRegisterInput('attorneyEmail', state.isSubmitted, errors, state)}
                                            />
                                            {errors?.attorneyEmail && (
                                                <FormFeedback className='ms-1'>{errors?.attorneyEmail?.message}</FormFeedback>
                                            )}
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row className='mt-3'>
                                    <Col sm={4}>
                                        <LabelBold>Was the LOP sent to the Attorney?</LabelBold>
                                    </Col>
                                    <Col sm={4} className='pe-4'>
                                        <Row>
                                            <Col sm={6}>
                                                <div className='d-flex justify-content-around flex-row'>
                                                    <div>No</div>
                                                    <div className="form-check form-switch">
                                                        <input
                                                            className='form-check-input'
                                                            type='checkbox'
                                                            id='wasLopSent'
                                                            name='wasLopSent'
                                                            onChange={(e) => dispatch({ type: 'SET', name: 'wasLopSent', value: e.target.checked })}
                                                            checked={state.wasLopSent || false}
                                                            style={{ transform: 'scale(1.6)' }}
                                                        />
                                                    </div>
                                                    <div>Yes</div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </>
                )}
                <Row className='mt-3 wizard-footer'>
                    <Col xs={{ size: 12 }} md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 3 }} className='text-end'>
                        <Button
                            color='primary'
                            onClick={gotToNextStep}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Submitting...
                                </>
                            ) : (
                                <>
                                    {(state.isPIWC || state.fullEVOrAccumulationsBenefits) ? 'Finish' : 'Next'} <ArrowRight />
                                </>
                            )}
                        </Button>
                    </Col>
                </Row>
                {/* <Button type='submit'>Lone Submit!</Button> */}

            </Form>


            {/* Report Date
      <p>Step 1</p>
      {isLoading && <p>loading...</p>}
      <button onClick={() => previousStep()}>Previous</button>
      <button onClick={() => nextStep()}>Next</button>
      <button onClick={() => goToStep(1)}>Go to the last step</button>
      <div>
        Has next step: {!isLastStep ? '✅' : '⛔'}
        <br />
        Has previous step : {!isFirstStep ? '✅' : '⛔'}
      </div>
      Active step: {activeStep + 1} <br /> */}
        </div>
    )
}

export default StepClinicInformation;